import { Component, ErrorInfo, ReactNode } from 'react'
import * as Sentry from '@sentry/browser'

import { Error } from '@tracklib/kit'

type ErrorBoundaryProps = {
  hidden?: boolean
  errorComponent?: ReactNode
  children?: ReactNode
}

type ErrorBoundaryState = {
  error: Error | null
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { error: null }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error })
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key as keyof ErrorInfo])
      })
      Sentry.captureException(error)
    })
    console.log(error, errorInfo) // eslint-disable-line
  }

  render() {
    const { hidden, errorComponent, children } = this.props
    if (this.state.error) {
      if (hidden) {
        return <div />
      }
      if (errorComponent) {
        return errorComponent
      }
      return <Error message="We're sorry, something's gone wrong…" emoji="sad" replacePageTitle={false} />
    }
    return children || null
  }
}

export default ErrorBoundary
